import React from "react";

import { PostStatus, PostType } from "@hubcapp/types";
import { useQueryPosts } from "@hubcapp/hooks";

import { PostList } from "../components";
import { useAuth } from "@hubcapp/context";

const StateProvider = () => {
  const {
    instructor: { id: instructorId },
  } = useAuth();
  const { data, loading } = useQueryPosts(instructorId, {
    type: [PostType.News],
    status: PostStatus.Live,
  });

  return <PostList loading={loading} posts={data?.instructor?.posts} />;
};

export default StateProvider;
